import { render, staticRenderFns } from "./IdeaPreview.vue?vue&type=template&id=18173245"
import script from "./IdeaPreview.vue?vue&type=script&lang=js"
export * from "./IdeaPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports